import Chip from "@mui/material/Chip"
import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import { deployStatusMeta, formatDateTime, formatDuration } from "./statusUtils"

export default function DeploysList({ deploys }) {
  return (
    <Column gap={0.75}>
      <Typography variant="overline" color="text.secondary">
        Recent deploys (CodePipeline)
      </Typography>
      {deploys.length ? (
        deploys.map((deploy) => {
          const meta = deployStatusMeta(deploy.status)
          const duration =
            deploy.status === "InProgress"
              ? null
              : formatDuration(deploy.started, deploy.finished)
          return (
            <Row
              key={deploy.id}
              sx={{ alignItems: "center", gap: 1, flexWrap: "wrap" }}
            >
              <Chip
                size="small"
                label={deploy.status}
                sx={{
                  bgcolor: meta.bg,
                  color: meta.color,
                  fontWeight: 600,
                  minWidth: 92,
                }}
              />
              <Typography variant="body2">
                {formatDateTime(deploy.started)}
              </Typography>
              {duration ? (
                <Typography variant="caption" color="text.secondary">
                  took {duration}
                </Typography>
              ) : null}
            </Row>
          )
        })
      ) : (
        <Typography variant="body2" color="text.secondary">
          No pipeline runs found.
        </Typography>
      )}
    </Column>
  )
}

DeploysList.propTypes = { deploys: PropTypes.array.isRequired }
